// @aide-title Group detail
// @aide-description A single group's details — the site and permission level it grants, which folders and documents are in its scope, and its members
// @aide-area Site Permissions
// @aide-area Users
import React from "react";
import { MaplesPage } from "components/pages";
import { GroupDetails } from "features/Groups/GroupDetails";

const GroupDetailsPage = ({ match }) => {
  const groupId = match.params.id;
  return (
    <MaplesPage headerItems={["Sites"]}>
      <GroupDetails groupId={groupId} />
    </MaplesPage>
  );
};

export default GroupDetailsPage;
